<script setup>
import { useIcons } from '@/composables/icons.js';
import { defineProps } from 'vue';
const props = defineProps({
  profilePic: {
    type: String,
    default: ''
  },
  profilePicture: {
    type: String,
    default: ''
  },
  size: {
    type: String,
    default: 'md'
  }
});

const { User } = useIcons();

const avatarSizeClasses = {
  sm: 'w-16 h-16',
  md: 'w-24 h-24',
  lg: 'w-32 h-32 sm:w-40 sm:h-40'
};

const avatarSize = avatarSizeClasses[props.size] || avatarSizeClasses.md;
</script>

<template>
  <div class="creator-profile__avatar-container">
    <img
      v-if="profilePic && profilePic !== ''"
      :src="profilePicture"
      alt="Profile avatar"
      :class="['creator-profile__avatar', avatarSize, 'rounded-full object-cover border-2 border-echoes-primary']"
    />
    <div v-else :class='[avatarSize, " p-6 text-gray-400 rounded-full object-cover ring-4 ring-echoes-primary"]'>
      <User />
    </div>
  </div>
</template>

<style scoped lang="postcss">
.creator-profile__avatar-container {
  @apply relative flex-shrink-0;
}
</style>
